import { useQuery } from 'react-query';
import { getResource } from '../../apis/V2/resource';

export const useResoure = (resourceId?: string) => {
	return useQuery({
		queryKey: ['getResource', resourceId],
		queryFn: async () => (await getResource({ resourceId })).data?.resource as any,
		staleTime: 60000,
		retry: false,
		refetchOnWindowFocus: false,
		enabled: !!resourceId,
	});
};
